import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'

const styles = theme => ({
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 200,
    marginLeft: '1rem'
  }
})

class ControlledOpenSelect extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      confirmation: props.default || 'hourFee',
      open: false,
    }
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
    this.props.onChange(event.target.name, event.target.value)
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  handleOpen = () => {
    this.setState({ open: true })
  }

  render() {
    const { classes } = this.props

    return (
      <form autoComplete="off">
        <FormControl className={classes.formControl}>
          <Select
            open={this.state.open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={this.state.confirmation}
            onChange={this.handleChange}
            inputProps={{
              name: 'confirmation',
              id: 'demo-controlled-open-select',
            }}
          >
            <MenuItem value={"hourFee"}>~1 hour</MenuItem>
            <MenuItem value={"halfHourFee"}>~30 minutes</MenuItem>
            <MenuItem value={"fastestFee"}>~10 minutes (fastest)</MenuItem>
          </Select>
        </FormControl>
      </form>
    )
  }
}

ControlledOpenSelect.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(ControlledOpenSelect)



// WEBPACK FOOTER //
// ./src/TimeSelector.js